import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AudioUploadPage from "../views/student/AudioUpload";
import ExpiredPage from "../views/authentication/ExpiredPage";
import ForgotPasswordPage from "../views/authentication/ForgotPassword";
import LoginPage from "../views/authentication/Login";
import PasswordResetPage from "../views/authentication/PasswordReset";
import ResetMassagePage from "../views/authentication/ResetMassage";
import RestoreMassagePage from "../views/authentication/RestoreMassage";
import SetPasswordPage from "../views/complete-account/SetPassword";
import FillAccountInfoPage from "../views/complete-account/AccountInfo";
import StudentTutorInfoPage from "../views/student/tutorInfo";
import SessionsPage from "../views/student/dashboard/SessionsView";
import StuReadingRoom from "../views/student/dashboard/ReadingRoom";
import ReadingRoom from "../views/tutor/dashboard/ReadingRoom";
import NotesViewPage from "../views/student/dashboard/NotesView";
import RoomPage from "../views/student/dashboard/Room";
import StudentDashboardPage from "../views/student/Dashboard";
import LiaisonDashboard from "../views/liaison/Dashboard";
import CandidatesView from "../views/liaison/dashboard/CandidatesView";
import RecitationTrackingView from "../views/liaison/dashboard/RecitationTrackingView";
import ScheduleView from "../views/liaison/dashboard/ScheduleView";
import SanadInfo from "../views/complete-account/SanadInfo";
import LiaisonPersonalInfo from "../views/liaison/dashboard/PersonalInfo";
import NotFoundPage from "../views/authentication/NotFoundPage";
import DashboardRedirector from "../views/DashboardRedirector";
import CreateFreeTimeSchedule from "../views/complete-account/CreateFreeTimeSchedule";
import Policies from "../views/student/Policies";
import LiaisonDashboardContainer from "../components/LiaisonDashboardContainer";
import { useAuth } from "../context/AuthContext";
import ActiveChatPage from "../views/chat/ActiveChatPage";
import PersonalStudentInfoPage from "../views/student/dashboard/personalInfo";
import WeeklyScheduleStudent from "../views/student/dashboard/WeeklySchedule";
import RequestsStudentInfo from "../views/student/dashboard/Requests";
import AppointmentsStudentRequests from "../views/student/dashboard/AppointmentsRequests";
import ChangeAppointments from "../views/student/ChangeAppointments";
import TutorRouter from "./tutor_router";
import RescheduleAppointments from "../views/student/dashboard/AppointmentsRequests/rescheduleAppointment";
import RequirementForm from "../views/requirement/RequirementForm";
import PaymentStudentPage from "../views/student/dashboard/PaymentPage";
import CandidateRouter from "./candidate_router";
import BookingCandidatePage from "../views/candidate/dashboard/personalInfo/BookingCandidatePage";
import BookingSuccessfullyPage from "../views/candidate/dashboard/BookingSucessfully";
import CalendarBookingPage from "../views/candidate/dashboard/CalendarBookingPage";
import ScheduledSuccessPage from "../views/candidate/dashboard/ScheduledSuccess";
import SessionWaitingPage from "../views/candidate/dashboard/SessionWaiting";
import ReadingRoomNewBoarding from "../views/candidate/dashboard/ReadingRoomNewBoarding";
import StudentProposedSchedule from "../views/complete-account/StudentProposedSchedule";
import StudentSkillsView from "../views/student/dashboard/SkillsView";
import AcceptanceEmailConfirmationPage from "../views/candidate/dashboard/AcceptanceEmailConfirmation";
import SupervisorRouter from "./supervisor_router";
import StudentProfile from "../views/shared-pages/StudentProfile";
import ChatPageWrapper from "../views/chat/ChatPageWrapper";
import PaymentStatusPage from "../views/shared-pages/PaymentStatusPage";
import RecitationRecordingPanel from "../views/candidate/dashboard/RecitationRecordingPanel";
import ReadingRecorder from "../views/candidate/dashboard/ReadingRecorder";
import AudioPreview from "../components/recorder/AudioPreview";

function AppRouter() {
  const LocalBasePath = "sidenav";
  let location: any = useLocation();

  const Context = useAuth();
  function RequireAuth({ children }: { children: JSX.Element }) {
    if (!Context?.userType) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
  }

  function GetDashboard() {
    if (Context?.userType === "liaison") {
      return (
        <Route
          path="/liaison/dashboard/"
          element={
            <RequireAuth>
              <LiaisonDashboard />
            </RequireAuth>
          }
        >
          <Route
            path="/liaison/dashboard/readers"
            element={<RecitationTrackingView />}
          />
          <Route
            path="/liaison/dashboard/candidates"
            element={<CandidatesView />}
          />

          <Route
            path="/liaison/dashboard/personal-data"
            element={<LiaisonPersonalInfo />}
          />
          <Route
            path="/liaison/dashboard/schedule"
            element={<ScheduleView />}
          />
          <Route
            path="/liaison/dashboard/student/:id"
            element={<StudentProfile />}
          />
          <Route
            path="/liaison/dashboard/*"
            element={<LiaisonDashboardContainer />}
          />
          <Route
            path="/liaison/dashboard/messages"
            element={<ActiveChatPage />}
          />
          <Route
            path="/liaison/dashboard/"
            element={<LiaisonDashboardContainer />}
          />
        </Route>
      );
    } else if (Context?.userType === "tutor") {
      return TutorRouter();
    } else if (Context?.userType === "supervisor") {
      return SupervisorRouter();
    } else if (Context?.userType === "candidate") {
      return CandidateRouter();
    } else {
      return (
        <Route
          path="/student/dashboard/"
          element={
            <RequireAuth>
              <StudentDashboardPage />
            </RequireAuth>
          }
        >
          <Route path="/student/dashboard/room" element={<RoomPage />} />
          <Route
            path="/student/dashboard/messages"
            element={<ChatPageWrapper />}
          />
          <Route
            path="/student/dashboard/sessions"
            element={<SessionsPage />}
          />
          <Route
            path="/student/dashboard/requests"
            element={<RequestsStudentInfo />}
          />
          <Route
            path="/student/dashboard/appointments-requests"
            element={<AppointmentsStudentRequests />}
          />
          <Route
            path="/student/dashboard/recitation-skills"
            element={<StudentSkillsView />}
          />
          <Route
            path="/student/dashboard/weekly-schedule"
            element={<WeeklyScheduleStudent />}
          />
          <Route path="/student/dashboard/notes" element={<NotesViewPage />} />
          <Route
            path="/student/dashboard/personal-info"
            element={<PersonalStudentInfoPage />}
          />
          <Route
            path="/student/dashboard/payment"
            element={<PaymentStudentPage />}
          />

          <Route
            path="/student/dashboard/weekly-schedule/update"
            element={<RescheduleAppointments />}
          />
          <Route
            path="/student/dashboard/*"
            element={<Navigate to="/student/dashboard/room" />}
          />
          <Route
            path="/student/dashboard/"
            element={<Navigate to="/student/dashboard/room" />}
          />
        </Route>
      );
    }
  }

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <DashboardRedirector />
            </RequireAuth>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/:id/password-reset" element={<PasswordResetPage />} />
        <Route path="/restore-password" element={<RestoreMassagePage />} />
        <Route path="/password-reset" element={<PasswordResetPage />} />
        <Route
          path="/tutor/fill-account-info"
          element={<FillAccountInfoPage />}
        />
        <Route
          path="/supervisor/fill-account-info"
          element={<FillAccountInfoPage />}
        />

        <Route path="/password-reset-message" element={<ResetMassagePage />} />
        <Route path="/tutor/sanad-info" element={<SanadInfo />} />
        <Route path="/tutor/free-time" element={<CreateFreeTimeSchedule />} />
        <Route path="/expired/:id" element={<ExpiredPage />} />
        <Route path="/password-reset" element={<PasswordResetPage />} />
        <Route path="/set-password/:id" element={<SetPasswordPage />} />
        {/* STUDENT ROUTES */}
        {/* TODO Change  user_id To UUID */}
        <Route
          path="/student/upload-audio/:user_id"
          element={<AudioUploadPage />}
        />
        <Route path="/policies" element={<Policies />} />
        <Route
          path="/requirement/fill-account-info"
          element={<RequirementForm />}
        />
        <Route
          path="/student/fill-account-info"
          element={<FillAccountInfoPage />}
        />
        <Route
          path="/student/payment"
          element={
            <PaymentStudentPage
              redirectUrl={`${window.location.origin}/student/proposed-schedule`}
            />
          }
        />
        <Route
          path="/student/proposed-schedule"
          element={<StudentProposedSchedule />}
        />
        <Route path="/student/tutor-info" element={<StudentTutorInfoPage />} />
        {/* LIAISON OFFICER ROUTES */}
        <Route
          path="/liaison/fill-account-info"
          element={<FillAccountInfoPage />}
        />
        <Route
          path="/learner/success-booking-account"
          element={<BookingSuccessfullyPage />}
        />
        <Route
          path="/learner/success-booking-session"
          element={<ScheduledSuccessPage />}
        />
        <Route
          path="/student/change-appointments"
          element={
            <RequireAuth>
              <ChangeAppointments />
            </RequireAuth>
          }
        />
        {/* <Route
          path="/tutor/change-appointments"
          element={
            <RequireAuth>
              <ChangeTutorAppointments />
            </RequireAuth>
          }
        /> */}
        {GetDashboard()}
        <Route
          path="/learner/fill-account-info"
          element={<BookingCandidatePage />}
        />
        <Route
          path="/learner/recitation-recording-panel"
          element={<RecitationRecordingPanel />}
        />
        <Route path="/learner/reading-recorder/:type" element={<ReadingRecorder />} />
        <Route path="/preview" element={<AudioPreview />} />
        <Route path="/learner/preview" element={<AudioPreview />} />
        <Route path="/student/preview" element={<AudioPreview />} />
        <Route path="/candidate/preview" element={<AudioPreview />} />
        <Route
          path="/learner/waiting-session/:learner_token"
          element={<SessionWaitingPage />}
        />
        <Route
          path="/learner/acceptance-email"
          element={<AcceptanceEmailConfirmationPage />}
        />
        <Route
          path="/tutor/dashboard/room/:id"
          element={
            <RequireAuth>
              <ReadingRoom />
            </RequireAuth>
          }
        />
        <Route
          path="/student/dashboard/room/:id"
          element={
            <RequireAuth>
              <StuReadingRoom />
            </RequireAuth>
          }
        />
        <Route
          path="/learner/booking-calendar/:learner_token"
          element={<CalendarBookingPage />}
        />
        <Route path="/learner/room/:id" element={<ReadingRoomNewBoarding />} />
        <Route
          path="/student/reschedule"
          element={
            <RequireAuth>
              <RescheduleAppointments />
            </RequireAuth>
          }
        />
        <Route
          path="/payment/verify/:payment_intent_id"
          element={<PaymentStatusPage />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
export default AppRouter;
